/* eslint-disable max-lines-per-function */
import React from 'react';
import { Dialog } from '../../../../kit/Dialog';
import { Layout } from '../../../../kit/Layout';
import { Text } from '../../../../kit/Text';
import { Button } from "../../../../kit/Button";

interface IProps {
    isOpen: boolean;
    setClosed: () => void;
    onConfirm?: () => void;
}

export const SyringeDriverConfirmMultipleDrugsDialog = (props: IProps) => {
    return (
        <Dialog lazy secondary open={props.isOpen} onRequestClose={() => props.setClosed()} size={'lg'}>
            <SyringeDriverConfirmMultipleDrugsForm {...props} />
        </Dialog>
    );
};

const SyringeDriverConfirmMultipleDrugsForm = (props: IProps) => {
    const handleConfirm = () => {
        props.setClosed();
        props.onConfirm?.();
    };

    return (
        <div style={{ paddingTop: '3rem' }}>
            <Layout gap={1}>
                <Text weight={'bold'} size={'medium'} style={{ paddingRight: '3rem', whiteSpace: 'normal', wordWrap: 'break-word'}}>
                    Please confirm that all required drugs have been selected for this driver.
                </Text>
                <Layout horizontal gap={1} justify="right" style={{ marginTop: '2em' }}>
                    <Button onClick={props.setClosed}>
                        Back
                    </Button>
                    <Button onClick={handleConfirm}>
                        Confirm
                    </Button>
                </Layout>
            </Layout>
        </div>
    );
}